import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`relative py-6 md:py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto ${className}`} data-id="element-248">
      {children}
    </section>;
}
export function Divider() {
  return <motion.div initial={{
    scaleX: 0,
    opacity: 0
  }} whileInView={{
    scaleX: 1,
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 1.5,
    ease: 'easeInOut'
  }} className="h-px w-full max-w-xs mx-auto bg-gradient-to-r from-transparent via-gold-500/50 to-transparent my-4 md:my-8" data-id="element-249" />;
}